// src/adhkar/adhkarData.js
// Objectif : 15 adhkâr IDENTIQUES matin/soir (Option A)
// - tout complet : arabe + translit + FR + EN
// - target = répétitions
// - source laissé vide (on cite la source une seule fois en haut via ADHKAR_SOURCE_*)

export const ADHKAR_SOURCE_FR =
  "Sources : Hisn al-Muslim (Fortress of the Muslim) ; Citadelle du musulman.";
export const ADHKAR_SOURCE_EN =
  "Sources: Hisn al-Muslim (Fortress of the Muslim); Citadelle du musulman.";

export const ADHKAR_NOTE_FR =
  " Coche “Fait” quand tu as terminé. Le compteur apparaît seulement si xN > 1. Fais ce que tu peux : ce n’est pas le nombre, mais la constance.";
export const ADHKAR_NOTE_EN =
  " Check “Done” when finished. Counter appears only when xN > 1. Do what you can: it’s not the amount, but consistency.";

// -------------------------------
// TEXTES COMPLETS
// -------------------------------

const AYAT_AL_KURSI_AR =
  "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَن ذَا الَّذِي يَشْفَعُ عِندَهُ إِلَّا بِإِذْنِهِ ۚ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِّنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ";

const AYAT_AL_KURSI_TRANSLIT =
  "Allāhu lā ilāha illā Huwa al-Ḥayyul-Qayyūm. Lā ta’khudhuhu sinatun wa lā nawm. Lahu mā fī as-samāwāti wa mā fī al-arḍ. Man dhā alladhī yashfa‘u ‘indahu illā bi’idhnih. Ya‘lamu mā bayna aydīhim wa mā khalfahum. Wa lā yuḥīṭūna bishay’in min ‘ilmih illā bimā shā’. Wasi‘a kursiyyuhu as-samāwāti wa al-arḍ. Wa lā ya’ūdhuḥu ḥifẓuhumā. Wa Huwa al-‘Aliyyul-‘Aẓīm.";

const AYAT_AL_KURSI_FR =
  "Allah ! Point de divinité en dehors de Lui, le Vivant, Celui qui subsiste par Lui-même. Ni somnolence ni sommeil ne Le saisissent. À Lui appartient tout ce qui est dans les cieux et sur la terre. Qui peut intercéder auprès de Lui sans Sa permission ? Il sait ce qui est devant eux et ce qui est derrière eux. Ils n’embrassent de Sa science que ce qu’Il veut. Son Kursî s’étend aux cieux et à la terre, et leur garde ne Lui coûte aucune peine. Et Il est le Très-Haut, le Très-Grand.";

const AYAT_AL_KURSI_EN =
  "Allah! None has the right to be worshiped except Him, the Ever-Living, the Sustainer of all. Neither drowsiness nor sleep overtakes Him. To Him belongs whatever is in the heavens and whatever is on the earth. Who can intercede with Him except by His permission? He knows what is before them and what is behind them. They encompass nothing of His knowledge except what He wills. His Kursī extends over the heavens and the earth, and preserving them does not tire Him. And He is the Most High, the Most Great.";

const IKHLAS_AR = `بِسْمِ اللهِ الرَّحْمَٰنِ الرَّحِيمِ
قُلْ هُوَ ٱللَّهُ أَحَدٌ
ٱللَّهُ ٱلصَّمَدُ
لَمْ يَلِدْ وَلَمْ يُولَدْ
وَلَمْ يَكُن لَّهُۥ كُفُوًا أَحَدٌ`;


const IKHLAS_TRANSLIT =
  "Qul huwa Allāhu Aḥad. Allāhu aṣ-Ṣamad. Lam yalid wa lam yūlad. Wa lam yakun lahu kufuwan aḥad.";

const IKHLAS_FR =
  "Dis : Il est Allah, Unique. Allah, Le Seul à être imploré pour ce que nous désirons. Il n’a pas engendré et n’a pas été engendré. Et nul n’est égal à Lui.";

const IKHLAS_EN =
  "Say: He is Allah, One. Allah, the Ever-Besought. He neither begets nor is born. And none is comparable to Him.";

const FALAQ_AR = `بِسْمِ اللهِ الرَّحْمَٰنِ الرَّحِيمِ
قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ
مِنْ شَرِّ مَا خَلَقَ
وَمِنْ شَرِّ غَاسِقٍ إِذَا وَقَبَ
وَمِنْ شَرِّ النَّفَّاثَاتِ فِي الْعُقَدِ
وَمِنْ شَرِّ حَاسِدٍ إِذَا حَسَدَ`;


const FALAQ_TRANSLIT =
  "Qul a‘ūdhu birabbi al-falaq. Min sharri mā khalaq. Wa min sharri ghāsiqin idhā waqab. Wa min sharri an-naffāthāti fī al-‘uqad. Wa min sharri ḥāsidin idhā ḥasad.";

const FALAQ_FR =
  "Dis : Je cherche protection auprès du Seigneur de l’aube, contre le mal de ce qu’Il a créé, contre le mal de l’obscurité quand elle s’intensifie, contre le mal de celles qui soufflent sur les nœuds, et contre le mal de l’envieux quand il envie.";

const FALAQ_EN =
  "Say: I seek refuge in the Lord of daybreak, from the evil of what He created, from the evil of darkness when it settles, from the evil of those who blow on knots, and from the evil of an envier when he envies.";

const NAS_AR = `بِسْمِ اللهِ الرَّحْمَٰنِ الرَّحِيمِ
قُلْ أَعُوذُ بِرَبِّ ٱلنَّاسِ
مَلِكِ ٱلنَّاسِ
إِلَٰهِ ٱلنَّاسِ
مِن شَرِّ ٱلْوَسْوَاسِ ٱلْخَنَّاسِ
ٱلَّذِى يُوَسْوِسُ فِى صُدُورِ ٱلنَّاسِ
مِنَ ٱلْجِنَّةِ وَٱلنَّاسِ`;

const NAS_TRANSLIT =
  "Qul a‘ūdhu birabbi an-nās. Maliki an-nās. Ilāhi an-nās. Min sharri al-waswāsi al-khannās. Alladhī yuwaswisu fī ṣudūri an-nās. Mina al-jinnati wa an-nās.";

const NAS_FR =
  "Dis : Je cherche protection auprès du Seigneur des hommes, le Souverain des hommes, le Dieu des hommes, contre le mal du mauvais conseiller, furtif, qui souffle le mal dans les poitrines des hommes, qu’il soit djinn ou homme.";

const NAS_EN =
  "Say: I seek refuge in the Lord of mankind, the King of mankind, the God of mankind, from the evil of the retreating whisperer, who whispers into the breasts of mankind—among jinn and mankind.";

// 5) Bismillah… rien ne peut nuire… (x3)
const BISMILLAH_LA_YADURR_AR =
  "بِسْمِ اللهِ الَّذِي لَا يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِي الْأَرْضِ وَلَا فِي السَّمَاءِ وَهُوَ السَّمِيعُ الْعَلِيمُ";

const BISMILLAH_LA_YADURR_TRANSLIT =
  "Bismillāhi alladhī lā yaḍurru ma‘a ismihi shay’un fī al-arḍi wa lā fī as-samā’i wa Huwa as-Samī‘u al-‘Alīm.";

const BISMILLAH_LA_YADURR_FR =
  "Au nom d’Allah : avec Son Nom, rien ne peut nuire sur terre ni dans le ciel. Et Il est l’Audient, l’Omniscient.";

const BISMILLAH_LA_YADURR_EN =
  "In the name of Allah—nothing can harm with His Name on earth or in the heavens. And He is the All-Hearing, the All-Knowing.";

// 6) Raditu billahi Rabban… (x3)
const RADITU_AR =
  "رَضِيتُ بِاللَّهِ رَبًّا وَبِالْإِسْلَامِ دِينًا وَبِمُحَمَّدٍ ﷺ نَبِيًّا";

const RADITU_TRANSLIT =
  "Raḍītu billāhi Rabban, wa bil-Islāmi dīnan, wa bi Muḥammadin ﷺ nabiyyan.";

const RADITU_FR =
  "J’agrée Allah comme Seigneur, l’Islam comme religion et Muhammad ﷺ comme Prophète.";

const RADITU_EN =
  "I am pleased with Allah as Lord, with Islam as religion, and with Muhammad ﷺ as Prophet.";

// 7) Sayyid al-Istighfar (x1)
const SAYYID_ISTIGHFAR_AR =
  "اللَّهُمَّ أَنْتَ رَبِّي لَا إِلَهَ إِلَّا أَنْتَ، خَلَقْتَنِي وَأَنَا عَبْدُكَ، وَأَنَا عَلَىٰ عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ، أَعُوذُ بِكَ مِنْ شَرِّ مَا صَنَعْتُ، أَبُوءُ لَكَ بِنِعْمَتِكَ عَلَيَّ، وَأَبُوءُ بِذَنْبِي، فَاغْفِرْ لِي، فَإِنَّهُ لَا يَغْفِرُ الذُّنُوبَ إِلَّا أَنْتَ";

const SAYYID_ISTIGHFAR_TRANSLIT =
  "Allāhumma anta Rabbī lā ilāha illā Anta, khalaqtanī wa anā ‘abduk, wa anā ‘alā ‘ahdika wa wa‘dika mā istaṭa‘t. A‘ūdhu bika min sharri mā ṣana‘t. Abū’u laka bini‘matika ‘alayya, wa abū’u bidhambī, faghfir lī, fa’innahu lā yaghfiru adh-dhunūba illā Anta.";

const SAYYID_ISTIGHFAR_FR =
  "Ô Allah ! Tu es mon Seigneur. Il n’y a aucune divinité [digne d’être adorée] en dehors de Toi. Tu m’as créé et je suis Ton serviteur, je me conforme autant que je peux à mon engagement et à ma promesse vis-à-vis de Toi. Je cherche refuge auprès de Toi contre le mal que j’ai commis. Je reconnais Ton bienfait à mon égard et je reconnais mon péché. Pardonne-moi donc, en effet nul autre que Toi ne pardonnes les péchés.";

const SAYYID_ISTIGHFAR_EN =
  "O Allah, You are my Lord. None has the right to be worshipped except You. You created me and I am Your servant, and I remain as faithful as I can to Your covenant and promise. I seek refuge in You from the evil of what I have done. I acknowledge Your favor upon me, and I acknowledge my sin. So forgive me, for none forgives sins except You.";

// 8) Subhanallah wa bihamdih (x100)
const SUBHAN_WA_BIHAMDIH_AR = "سُبْحَانَ اللهِ وَبِحَمْدِهِ";
const SUBHAN_WA_BIHAMDIH_TRANSLIT = "Subḥānallāhi wa biḥamdih.";
const SUBHAN_WA_BIHAMDIH_FR = "Gloire et louange à Allah.";
const SUBHAN_WA_BIHAMDIH_EN = "Glory and praise be to Allah.";

// 9) La ilaha illa Allah wahdahu… (x10)
const TAWHID_100_AR =
  "لَا إِلَٰهَ إِلَّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ، وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ";

const TAWHID_100_TRANSLIT =
  "Lā ilāha illā Allāhu waḥdahu lā sharīka lah, lahu al-mulku wa lahu al-ḥamd, wa Huwa ‘alā kulli shay’in qadīr.";

const TAWHID_100_FR =
  "Nul n’est adoré en vérité sauf Allah, Unique, sans associé. À Lui la royauté, à Lui la louange, et Il est capable de toute chose.";

const TAWHID_100_EN =
  "None has the right to be worshiped except Allah alone, without partner. To Him belongs sovereignty and praise, and He is able to do all things.";

// 10) Allahumma inni as’aluka al-‘afwa wal-‘afiyah… (x1)
const AFWA_AFIYAH_AR =
  "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي الدُّنْيَا وَالْآخِرَةِ، اللّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي دِينِي وَدُنْيَايَ وَأَهْلِي وَمَالِي، اللّهُمَّ اسْتُرْ عَوْرَاتِي وَآمِنْ رَوْعَاتِي، اللّهُمَّ احْفَظْنِي مِنْ بَيْنِ يَدَيَّ وَمِنْ خَلْفِي وَعَنْ يَمِينِي وَعَنْ شِمَالِي وَمِنْ فَوْقِي، وَأَعُوذُ بِعَظَمَتِكَ أَنْ أُغْتَالَ مِنْ تَحْتِي";

const AFWA_AFIYAH_TRANSLIT =
  "Allāhumma innī as’aluka al-‘afwa wal-‘āfiyah fī ad-dunyā wal-ākhirah. Allāhumma innī as’aluka al-‘afwa wal-‘āfiyah fī dīnī wa dunyāya wa ahlī wa mālī. Allāhumma’stur ‘awrātī wa āmin raw‘ātī. Allāhumma’ḥfaẓnī min bayni yadayya wa min khalfī wa ‘an yamīnī wa ‘an shimālī wa min fawqī, wa a‘ūdhu bi‘aẓamatika an ughtāla min taḥtī.";

const AFWA_AFIYAH_FR =
  "Ô Allah ! Je te demande le salut dans cette vie et dans l’au-delà. Ô Allah ! Je Te demande le pardon et le salut dans ma religion, ma vie, ma famille et mes biens. Ô Allah ! Cache mes défauts et mets-moi à l’abri de toutes mes craintes. Ô Allah ! Protège-moi par devant, par derrière, sur ma droite, sur ma gauche et au-dessus de moi. Je me mets sous la protection de Ta grandeur pour ne pas être enseveli.";

const AFWA_AFIYAH_EN =
  "O Allah, I ask You for well-being in this world and in the Hereafter. O Allah, I ask You for pardon and well-being in my religion, my worldly affairs, my family and my wealth. O Allah, conceal my faults and calm my fears. O Allah, protect me from in front of me and from behind me, from my right and from my left, and from above me. And I seek refuge in Your (greatness) from being taken unawares from beneath me.";

// 11) Allahumma bika asbahna / amsayna… (x1) — version “matin/soir”
const ASBAHNA_AMSAYNA_AR =
  "اللَّهُمَّ بِكَ أَصْبَحْنَا وَبِكَ أَمْسَيْنَا، وَبِكَ نَحْيَا وَبِكَ نَمُوتُ، وَإِلَيْكَ النُّشُورُ";

const ASBAHNA_AMSAYNA_TRANSLIT =
  "Allāhumma bika aṣbaḥnā wa bika amsaynā, wa bika naḥyā wa bika namūt, wa ilayka an-nushūr.";

const ASBAHNA_AMSAYNA_FR =
  "Ô Allah, par Toi nous atteignons le matin et par Toi nous atteignons le soir ; par Toi nous vivons et par Toi nous mourons ; et vers Toi est la résurrection.";

const ASBAHNA_AMSAYNA_EN =
  "O Allah, by You we enter the morning and by You we enter the evening; by You we live and by You we die; and to You is the resurrection.";

// 11b) Allahumma bika amsayna / asbahna… (x1) — version SOIR (inverse)
const AMSAYNA_ASBAHNA_AR =
  "اللَّهُمَّ بِكَ أَمْسَيْنَا وَبِكَ أَصْبَحْنَا، وَبِكَ نَحْيَا وَبِكَ نَمُوتُ، وَإِلَيْكَ الْمَصِيرُ";

const AMSAYNA_ASBAHNA_TRANSLIT =
  "Allāhumma bika amsaynā wa bika aṣbaḥnā, wa bika naḥyā wa bika namūt, wa ilayka al-maṣīr.";

const AMSAYNA_ASBAHNA_FR =
  "Ô Allah, par Toi nous atteignons le soir et par Toi nous atteignons le matin ; par Toi nous vivons et par Toi nous mourons ; et vers Toi est le retour.";

const AMSAYNA_ASBAHNA_EN =
  "O Allah, by You we enter the evening and by You we enter the morning; by You we live and by You we die; and to You is the return.";

  // 12) Ya Hayyu Ya Qayyum… (x1)
const YA_HAYYU_AR =
  "يَا حَيُّ يَا قَيُّومُ، بِرَحْمَتِكَ أَسْتَغِيثُ، أَصْلِحْ لِي شَأْنِي كُلَّهُ، وَلَا تَكِلْنِي إِلَىٰ نَفْسِي طَرْفَةَ عَيْنٍ";

const YA_HAYYU_TRANSLIT =
  "Yā Ḥayyu yā Qayyūm, biraḥmatika astaghīth. Aṣliḥ lī sha’nī kullah, wa lā takilnī ilā nafsī ṭarfata ‘ayn.";

const YA_HAYYU_FR =
  "Ô Toi le Vivant, Celui qui n’a besoin de rien et dont toute chose dépend, j’implore secours auprès de Ta miséricorde. Améliore ma situation en tout point et ne me laisse pas à mon propre sort ne serait-ce le temps d’un clin d’œil. ";

const YA_HAYYU_EN =
  "O Ever-Living, O Sustainer, I seek help through Your mercy. Rectify all of my affairs and do not leave me to myself even for the blink of an eye.";

// 13) Salawât longue (x10) — Ibrahimiyyah
const SALAWAT_LONG_AR =
  "اللَّهُمَّ صَلِّ عَلَىٰ مُحَمَّدٍ وَعَلَىٰ آلِ مُحَمَّدٍ، كَمَا صَلَّيْتَ عَلَىٰ إِبْرَاهِيمَ وَعَلَىٰ آلِ إِبْرَاهِيمَ، إِنَّكَ حَمِيدٌ مَجِيدٌ. اللَّهُمَّ بَارِكْ عَلَىٰ مُحَمَّدٍ وَعَلَىٰ آلِ مُحَمَّدٍ، كَمَا بَارَكْتَ عَلَىٰ إِبْرَاهِيمَ وَعَلَىٰ آلِ إِبْرَاهِيمَ، إِنَّكَ حَمِيدٌ مَجِيدٌ";

const SALAWAT_LONG_TRANSLIT =
  "Allāhumma ṣalli ‘alā Muḥammadin wa ‘alā āli Muḥammad, kamā ṣallayta ‘alā Ibrāhīma wa ‘alā āli Ibrāhīm, innaka Ḥamīdun Majīd. Allāhumma bārik ‘alā Muḥammadin wa ‘alā āli Muḥammad, kamā bārakta ‘alā Ibrāhīma wa ‘alā āli Ibrāhīm, innaka Ḥamīdun Majīd.";

const SALAWAT_LONG_FR =
  "Ô Allah, prie sur Muhammad et sur la famille de Muhammad, comme Tu as prié sur Ibrahim et sur la famille d’Ibrahim. Tu es, certes, Digne de louange et de gloire. Ô Allah, bénis Muhammad et la famille de Muhammad, comme Tu as béni Ibrahim et la famille d’Ibrahim. Tu es, certes, Digne de louange et de gloire.";

const SALAWAT_LONG_EN =
  "O Allah, send prayers upon Muhammad and upon the family of Muhammad, as You sent prayers upon Ibrahim and upon the family of Ibrahim. Indeed, You are Praiseworthy and Glorious. O Allah, bless Muhammad and the family of Muhammad, as You blessed Ibrahim and the family of Ibrahim. Indeed, You are Praiseworthy and Glorious.";

// 14) Allahumma ‘afini… (x3) — 2 parties (comme tu l’as signalé)
const AFINI_2PARTS_AR =
  "اللَّهُمَّ عَافِنِي فِي بَدَنِي، اللَّهُمَّ عَافِنِي فِي سَمْعِي، اللَّهُمَّ عَافِنِي فِي بَصَرِي، لَا إِلَٰهَ إِلَّا أَنْتَ.\nاللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْكُفْرِ وَالْفَقْرِ، وَأَعُوذُ بِكَ مِنْ عَذَابِ الْقَبْرِ، لَا إِلَٰهَ إِلَّا أَنْتَ";

const AFINI_2PARTS_TRANSLIT =
  "Allāhumma ‘āfinī fī badanī, Allāhumma ‘āfinī fī sam‘ī, Allāhumma ‘āfinī fī baṣarī, lā ilāha illā Ant.\nAllāhumma innī a‘ūdhu bika mina al-kufri wa al-faqr, wa a‘ūdhu bika min ‘adhābi al-qabr, lā ilāha illā Ant.";

const AFINI_2PARTS_FR =
  "Ô Allah, accorde-moi la santé dans mon corps, dans mon ouïe et dans ma vue ; nul n’est adoré en dehors de Toi. Ô Allah, je cherche refuge auprès de Toi contre la mécréance et la pauvreté, et je cherche refuge auprès de Toi contre le châtiment de la tombe ; nul n’est adoré en dehors de Toi.";

const AFINI_2PARTS_EN =
  "O Allah, grant me well-being in my body, in my hearing, and in my sight; none has the right to be worshiped except You. O Allah, I seek refuge in You from disbelief and poverty, and I seek refuge in You from the punishment of the grave; none has the right to be worshiped except You.";

// 15) Astaghfirullah wa atubu ilayh (x10)
const ASTAGHFIR_10_AR = "أَسْتَغْفِرُ اللهَ وَأَتُوبُ إِلَيْهِ";
const ASTAGHFIR_10_TRANSLIT = "Astaghfirullāha wa atūbu ilayh.";
const ASTAGHFIR_10_FR = "Je demande pardon à Allah et je me repens à Lui.";
const ASTAGHFIR_10_EN = "I seek Allah’s forgiveness and I repent to Him.";

// 16) Allahumma inni as’aluka ‘ilman nafi‘a… (x3)
const ILMAN_NAFIAN_AR =
  "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْمًا نَافِعًا، وَرِزْقًا طَيِّبًا، وَعَمَلًا مُتَقَبَّلًا";
const ILMAN_NAFIAN_TRANSLIT =
  "Allāhumma innī as’aluka ‘ilman nāfi‘an, wa rizqan ṭayyiban, wa ‘amalan mutaqabbalan.";
const ILMAN_NAFIAN_FR =
  "Ô Allah ! Je Te demande un savoir utile, une subsistance licite et des œuvres que Tu agréés.";
const ILMAN_NAFIAN_EN =
  "O Allah, I ask You for beneficial knowledge, good (lawful) provision, and deeds that are accepted.";

// 17) SubhanaLlahi wa bihamdih ‘adada khalqih… (x3)
const SUBHANA_ADADA_AR =
  "سُبْحَانَ اللهِ وَبِحَمْدِهِ، عَدَدَ خَلْقِهِ، وَرِضَا نَفْسِهِ، وَزِنَةَ عَرْشِهِ، وَمِدَادَ كَلِمَاتِهِ";
const SUBHANA_ADADA_TRANSLIT =
  "Subḥānallāhi wa biḥamdih, ‘adada khalqih, wa riḍā nafsih, wa zinata ‘arshih, wa midāda kalimātih.";
const SUBHANA_ADADA_FR =
  "Gloire et louange à Allah, autant que le nombre de Ses créatures, autant de fois qu’il le faut pour Le satisfaire, d’un nombre égal au poids de Son Trône et au nombre indéterminé de Ses paroles.";
const SUBHANA_ADADA_EN =
  "Glory and praise be to Allah, as many times as the number of His creation, as much as pleases Him, as heavy as His Throne, and as vast as the ink of His words.";

// 18) SubhanaLlahi-l-‘Azim wa bihamdih (x100)
const SUBHANA_AZIM_100_AR = "سُبْحَانَ اللهِ الْعَظِيمِ وَبِحَمْدِهِ";
const SUBHANA_AZIM_100_TRANSLIT = "Subḥānallāhi-l-‘Aẓīmi wa biḥamdih.";
const SUBHANA_AZIM_100_FR = "Gloire, pureté et louange à Allah l’Immense.";
const SUBHANA_AZIM_100_EN = "Glory and praise be to Allah, the Magnificent.";


// -------------------------------
// LISTE DES 15 (identique matin/soir)
// -------------------------------
const BASE_15 = [
  {
    id: "ayat_kursi",
    titleFr: "Âyat al-Kursî",
    titleEn: "Ayat al-Kursi",
    ar: AYAT_AL_KURSI_AR,
    translit: AYAT_AL_KURSI_TRANSLIT,
    fr: AYAT_AL_KURSI_FR,
    en: AYAT_AL_KURSI_EN,
    target: 1,
    source: "",
  },
  {
    id: "ikhlas",
    titleFr: "Al-Ikhlâs (112)",
    titleEn: "Al-Ikhlas (112)",
    ar: IKHLAS_AR,
    translit: IKHLAS_TRANSLIT,
    fr: IKHLAS_FR,
    en: IKHLAS_EN,
    target: 3,
    source: "",
  },
  {
    id: "falaq",
    titleFr: "Al-Falaq (113)",
    titleEn: "Al-Falaq (113)",
    ar: FALAQ_AR,
    translit: FALAQ_TRANSLIT,
    fr: FALAQ_FR,
    en: FALAQ_EN,
    target: 3,
    source: "",
  },
  {
    id: "nas",
    titleFr: "An-Nâs (114)",
    titleEn: "An-Nas (114)",
    ar: NAS_AR,
    translit: NAS_TRANSLIT,
    fr: NAS_FR,
    en: NAS_EN,
    target: 3,
    source: "",
  },
  {
    id: "bismillah_la_yadurr",
    titleFr: "“Bismillâh… rien ne peut nuire…”",
    titleEn: "“Bismillah… nothing can harm…”",
    ar: BISMILLAH_LA_YADURR_AR,
    translit: BISMILLAH_LA_YADURR_TRANSLIT,
    fr: BISMILLAH_LA_YADURR_FR,
    en: BISMILLAH_LA_YADURR_EN,
    target: 3,
    source: "",
  },
  {
  id: "ilman_nafian",
  titleFr: "“Allâhumma innî as’aluka ‘ilman nâfi‘a…”",
  titleEn: "“Allahumma inni as’aluka ‘ilman nafi‘a…”",
  ar: ILMAN_NAFIAN_AR,
  translit: ILMAN_NAFIAN_TRANSLIT,
  fr: ILMAN_NAFIAN_FR,
  en: ILMAN_NAFIAN_EN,
  target: 3, // ✅ compteur x3
  source: "",
},
  {
    id: "raditu",
    titleFr: "“Radîtu billâhi Rabban…”",
    titleEn: "“Raditu billahi Rabban…”",
    ar: RADITU_AR,
    translit: RADITU_TRANSLIT,
    fr: RADITU_FR,
    en: RADITU_EN,
    target: 3,
    source: "",
  },
    {
    id: "subhana_adada",
    titleFr: "“Subhânallâh wa bihamdih… ‘adada khalqih…”",
    titleEn: "“SubhanAllah wa bihamdih… ‘adada khalqih…”",
    ar: SUBHANA_ADADA_AR,
    translit: SUBHANA_ADADA_TRANSLIT,
    fr: SUBHANA_ADADA_FR,
    en: SUBHANA_ADADA_EN,
    target: 3,
    source: "",
  },
  {
    id: "sayyid_istighfar",
    titleFr: "Sayyid al-Istighfâr",
    titleEn: "Sayyid al-Istighfar",
    ar: SAYYID_ISTIGHFAR_AR,
    translit: SAYYID_ISTIGHFAR_TRANSLIT,
    fr: SAYYID_ISTIGHFAR_FR,
    en: SAYYID_ISTIGHFAR_EN,
    target: 1,
    source: "",
  },
  {
    id: "subhan_wabihamdih_100",
    titleFr: "“Subhânallâh wa bihamdih”",
    titleEn: "“SubhanAllah wa bihamdih”",
    ar: SUBHAN_WA_BIHAMDIH_AR,
    translit: SUBHAN_WA_BIHAMDIH_TRANSLIT,
    fr: SUBHAN_WA_BIHAMDIH_FR,
    en: SUBHAN_WA_BIHAMDIH_EN,
    target: 100,
    source: "",
  },
    {
    id: "subhana_azim_100",
    titleFr: "“SubhânaLlâhi-l-‘Azîm wa bihamdih”",
    titleEn: "“SubhanaLlahi-l-‘Azim wa bihamdih”",
    ar: SUBHANA_AZIM_100_AR,
    translit: SUBHANA_AZIM_100_TRANSLIT,
    fr: SUBHANA_AZIM_100_FR,
    en: SUBHANA_AZIM_100_EN,
    target: 100,
    source: "",
  },
  {
    id: "tawhid_10",
    titleFr: "“Lâ ilâha illa Allâh wahdahû…”",
    titleEn: "“La ilaha illa Allah wahdahu…”",
    ar: TAWHID_100_AR,
    translit: TAWHID_100_TRANSLIT,
    fr: TAWHID_100_FR,
    en: TAWHID_100_EN,
    target: 10,
    source: "",
  },
  {
    id: "afwa_afiyah",
    titleFr: "“Allâhumma innî as’aluka al-‘afwa wal-‘âfiyah…”",
    titleEn: "“Allahumma inni as’aluka al-‘afwa wal-‘afiyah…”",
    ar: AFWA_AFIYAH_AR,
    translit: AFWA_AFIYAH_TRANSLIT,
    fr: AFWA_AFIYAH_FR,
    en: AFWA_AFIYAH_EN,
    target: 1,
    source: "",
  },
  {
    id: "asbahna_amsayna",
    titleFr: "“Allâhumma bika asbahna… wa bika amsayna…”",
    titleEn: "“Allahumma bika asbahna… wa bika amsayna…”",
    ar: ASBAHNA_AMSAYNA_AR,
    translit: ASBAHNA_AMSAYNA_TRANSLIT,
    fr: ASBAHNA_AMSAYNA_FR,
    en: ASBAHNA_AMSAYNA_EN,
    target: 1,
    source: "",
  },
  {
    id: "ya_hayyu",
    titleFr: "“Yâ Hayyu Yâ Qayyûm…”",
    titleEn: "“Ya Hayyu Ya Qayyum…”",
    ar: YA_HAYYU_AR,
    translit: YA_HAYYU_TRANSLIT,
    fr: YA_HAYYU_FR,
    en: YA_HAYYU_EN,
    target: 1,
    source: "",
  },
  {
    id: "salawat_long_10",
    titleFr: "Salawât (version longue)",
    titleEn: "Salawat (long form)",
    ar: SALAWAT_LONG_AR,
    translit: SALAWAT_LONG_TRANSLIT,
    fr: SALAWAT_LONG_FR,
    en: SALAWAT_LONG_EN,
    target: 10,
    source: "",
  },
  {
    id: "afini_2parts",
    titleFr: "“Allâhumma ‘âfini…” (2 parties)",
    titleEn: "“Allahumma ‘afini…” (2 parts)",
    ar: AFINI_2PARTS_AR,
    translit: AFINI_2PARTS_TRANSLIT,
    fr: AFINI_2PARTS_FR,
    en: AFINI_2PARTS_EN,
    target: 3,
    source: "",
  },
  {
    id: "astaghfir_10",
    titleFr: "“Astaghfirullâh wa atûbu ilayh”",
    titleEn: "“Astaghfirullah wa atubu ilayh”",
    ar: ASTAGHFIR_10_AR,
    translit: ASTAGHFIR_10_TRANSLIT,
    fr: ASTAGHFIR_10_FR,
    en: ASTAGHFIR_10_EN,
    target: 10,
    source: "",
  },
];

// ✅ EVENING : même base, sauf l’invocation "asbahna_amsayna" remplacée par la version soir
const EVENING_15 = BASE_15.map((it) => {
  if (it.id !== "asbahna_amsayna") return it;

  return {
    ...it,
    id: "amsayna_asbahna",
    titleFr: "“Allâhumma bika amsayna… wa bika asbahna…”",
    titleEn: "“Allahumma bika amsayna… wa bika asbahna…”",
    ar: AMSAYNA_ASBAHNA_AR,
    translit: AMSAYNA_ASBAHNA_TRANSLIT,
    fr: AMSAYNA_ASBAHNA_FR,
    en: AMSAYNA_ASBAHNA_EN,
  };
});

// ✅ Option A : identiques matin/soir
export const MORNING_ADHKAR = BASE_15;
export const EVENING_ADHKAR = EVENING_15;

